<template>
    <div>
        <div v-if="connectionState">
            <Button icon="ri-wifi-line ri-lg" severity="success" rounded aria-label="Connection Status" />
        </div>
        <div v-else>
            <Button icon="ri-wifi-off-line ri-lg" severity="danger" rounded aria-label="Connection Status" />
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import EventBus from '@/libs/AppEventBus'
import Button from 'primevue/button'

const connectionState = ref(false)

const handleConnectionStateChange = (event) => {
    connectionState.value = event.online

    EventBus.emit('show-toast', {
        severity: connectionState.value ? 'success' : 'error',
        summary: '',
        detail: connectionState.value ? 'Connected to GetStream' : 'Disconnected from GetStream',
        life: 3000
    })
}

onMounted(() => {
    EventBus.on('gs-connection-state-changed', handleConnectionStateChange)
})
</script>
